export let CHANGE_DETAIL = "detail/CHANGE_DETAIL";
